export const TABLE_NAME_ACTIVITY_LIST_CAPITAL_RAISE: string = 'activity-list-capital-raise';
export const TABLE_NAME_ASSET_LIST: string = 'asset-list';
export const TABLE_NAME_CONTACT_LIST: string = 'contact-list';
export const TABLE_NAME_DEAL_LIST: string = 'deal-list';
export const TABLE_NAME_DEAL_CAPITALIZATION: string = 'deal-capitalization';
export const TABLE_NAME_DEAL_PARTICIPANT_LIST: string = 'deal-participant-list';
export const TABLE_NAME_DEAL_SCHEDULE_TASK_LIST: string = 'deal-schedule-task-list';
export const TABLE_NAME_ACTIVITY_LIST_DEAL: string = 'activity-list-deal';
